import { FieldConfig } from './field-config.model';

export class TemplateFieldConfig {
    public fieldConfig: FieldConfig;
    public templateFieldConfigId: number;
    public templateId: number;
    public type: string;

    public static build(): TemplateFieldConfig {
        const templateFieldConfig: TemplateFieldConfig = new TemplateFieldConfig();
        templateFieldConfig.fieldConfig = null;
        templateFieldConfig.templateFieldConfigId = null;
        templateFieldConfig.templateId = null;
        templateFieldConfig.type = null;
        return templateFieldConfig;
    }
}